<div>
  <p class="text-red-500">{{ errorFormate }}</p>
  <div class="grid grid-cols-2 gap-4 bg-white">
    <div *ngFor="let field of inputField; let i = index" class="flex mx-2">
      <ng-container *ngIf="field.name === 'is_dap'; else inputFieldTemplate" >
        <p class="mx-2">IS DAP :</p>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="formData.is_dap" [name]="'is_dap'" />
          <div class="slider round btn-primary">
            <!-- Ensure only the active state is displayed -->
            <span *ngIf="formData.is_dap" class="true">True</span>
            <span *ngIf="!formData.is_dap" class="false">False</span>
          </div>
        </label>
      </ng-container>

      <ng-template #inputFieldTemplate>
        <input #dobInput [type]="field.name === 'dob' ? 'text' : 'text'" [(ngModel)]="formData[field.name]"
          [placeholder]="field.name === 'dob' ? 'DOB (MM/DD/YYYY) *' : field.label" [name]="field.name"
          [attr.maxlength]="getMaxLength(field.name)" (input)="validateNumberField($event, field.name)"
          class="form-control rounded-md m-2 p-0.5 pr-15 border border-gray-300" />
      </ng-template>
    </div>
  </div>
  <div class="flex gap-2 my-2 pr-1 w-full justify-end items-center">
    <button class="btn" (click)="cancelForm()">Clear</button>
    <button class="btn btn-primary" (click)="submitForm()">Confirm</button>
  </div>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <app-status-messages [tosterMessage]="tosterMessage"></app-status-messages>
</div>